import ContextMenuComponent from '../../../../organisms/context-menu'

const MenuHeaderDefault = ({ options }) => {
  if (!options) return null

  return (
    <>
      {options.map((option) => (
        <ContextMenuComponent.Item key={String(option.id)} {...option} />
      ))}
    </>
  )
}
export default MenuHeaderDefault
